import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { ServicePoints } from "../../Objects/ServicePoint/ServicePoints"
import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useGetServicePoints } from "./useGetServicePoints"

export const useSaveServicePoint = () => {
  const { t } = useTranslation("general")
  
  const { enableLoad, disableLoad } = useLoad()
  
  const { setError } = useError()
  
  const { handleGetServicePoints } = useGetServicePoints()

  const handleSave = async (servicePoint: ServicePoints, onSuccess: () => void) => {
    enableLoad()

    try {
      const response =
        servicePoint.id === -1
          ? await PostFormRequest(API_ROUTES.SERVICE_POINT.CREATE, servicePoint.toJSON())
          : await PutFormRequest(`${API_ROUTES.SERVICE_POINT.PUT}/${servicePoint.id}`, servicePoint.toJSON())

      if (!response.success) {
        throw new Error(response.message)
      }

      await handleGetServicePoints(onSuccess)
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleSave }
}
